import script from "./RoadmapPhase.vue?vue&type=script&setup=true&lang=js"
export * from "./RoadmapPhase.vue?vue&type=script&setup=true&lang=js"

import "./RoadmapPhase.vue?vue&type=style&index=0&id=0ad77c15&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ad77c15"]])

export default __exports__